





































import {
  HasTaskMixin, Loader, MiniPagination, Message, ShowFinally,
} from 'mycorems-app-shared';
import isGranted from '../auth/isGranted';
import repository from './user-repository';
import { User, QueryFilters, QueryResult } from '../types';
import UserStatus from './status/UserStatus.vue';
import RouterLink from '../routing/RouterLink.vue';

interface Data {
  page: number,
  perPage: number,
  total: number,
  users: User[],
}

export default HasTaskMixin.extend({
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  data(): Data {
    return {
      page: 1,
      perPage: 5,
      total: 0,
      users: [],
    };
  },
  watch: {
    accountId: {
      handler(): void {
        this.refresh();
      },
      immediate: true,
    },
    filters: {
      handler(): void {
        this.load();
      },
      deep: true,
    },
  },
  computed: {
    offset(): number {
      return (this.page - 1) * this.perPage;
    },
    filters(): QueryFilters {
      return {
        limit: this.perPage,
        offset: this.offset,
      };
    },
  },
  methods: {
    unshift(user: User): void {
      this.users.unshift(user);
    },
    changePage(event): void {
      this.page = event.page;
    },
    refresh() {
      this.page = 1;
      this.load();
    },
    load(): void {
      this.task = repository.findAll(this.accountId, this.filters);
      this.task.then((result: QueryResult) => {
        this.total = result.total;
        this.users = (result.items as User[]);
      });
    },
    isGranted,
  },
  created(): void {
    this.load();
  },
  components: {
    Loader,
    UserStatus,
    MiniPagination,
    Message,
    ShowFinally,
    RouterLink,
  },
});
